/* eslint-disable class-methods-use-this */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import { createContext, Component } from '@wordpress/element';
import axios from 'axios';

const Highmaps = require('highcharts/highmaps');

const UserContext = createContext();

class UserProvider extends Component {
    state = {
        data: [],
        mapSeries: [],
        loading: false,
        states: [],
        msa: [],
    };

    async componentDidMount() {
        await this.getData();
    }

    async getData() {
        const res = await axios.get(
            `https://www.pewresearch.org/wp-json/prc-api/v2/interactive?slug=intermarriage-map`,
        );

        const mapSeries = [];

        res.data.map(d => {
            return mapSeries.push({
                name: d.metro_name,
                value: d.total,
                msa: d.msa_code,
            });
        });

        this.setState({ data: res.data.splice(1), mapSeries }, () => {
            this.setState({ loading: true });
        });
    }

    async getMapData() {
        const geojson = await axios.get(
            '//assets.pewresearch.org/interactives/socialtrends/2017/intermarriage-map/index.json',
        );

        const states = Highmaps.geojson(geojson.data, 'mapline');
        const msa = Highmaps.geojson(geojson.data, 'map');

        this.setState({ states, msa });
    }

    render() {
        const { children } = this.props;

        return (
            <UserContext.Provider
                value={{
                    ...this.state,
                }}
            >
                {children}
            </UserContext.Provider>
        );
    }
}

export default UserContext;

export { UserProvider };
